<template>
  <div class="logo_icon">
    <img src="@/assets/img/logo_icon.png" alt="" />
  </div>
</template>

<script>
export default {
  name: 'LogoIcon',
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style scoped lang='less'>
.logo_icon {
  display: flex;
  justify-content: center;
  margin-top: 64px;
  img {
    width: 163px;
    height: 114px;
  }
}
</style>
